RshopApp.$mount('.l-header');

let lightGallerySettings = {
    autoplay: false,
    autoplayControls: false,
    thumbnail: false,
    download: false,
    share: false,
    fullScreen: false,
    videoMaxWidth: "1140px",
    iframeMaxWidth: "100%",
    enableDrag: true,
    enableTouch: true,
    zoom: false
};

function freezeScroll(show) {
    $('body').toggleClass('freezeScroll', show);
    $('html').toggleClass('freezeScroll', show);
}

$('.modal').on('show.bs.modal', function () {
    freezeScroll(true);
});

$('.modal').on('hidden.bs.modal', function () {
    freezeScroll();
});

function checkMedia(query) {
    let isVisible = false,
        breakPoints = query.split(',');

    $.each(breakPoints, function (key, breakPoint) {
        if (!isVisible) {
            isVisible = $('.c-var__item.' + breakPoint + '-is-visible').is(':visible');
        }
    });

    return isVisible;
}

function watchdogModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-form-modal-watchdog').validate({
        rules: {
            notification_price: {
                number: true
            }
        },
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-watchdog-error').slideUp(100);
            $('.js-watchdog-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').prop('disabled', false);

                if (!data.status) {
                    $('.js-watchdog-error')
                        .text(data.msg)
                        .slideDown(200);
                } else {
                    $('.js-watchdog-success')
                        .text(data.msg)
                        .slideDown(200);
                    $('.js-watchdog-hide').slideUp(200);
                }
            }, 'json');
        }
    });
}

function setWishlistQuantity(form) {
    var $form = $(form);
    var productId = $form.find('input[name="product_id"]').val();
    var $quantity = $form.find('input[name="quantity"]');
    var $cartQuantity = $('input[name="quantity"][data-product-id="' + productId + '"]:visible');

    if (!$cartQuantity.size()) {
        return;
    }

    $quantity.val(parseInt($cartQuantity.val()));
}

function wishlistModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-wishlist-form').validate({
        submitHandler: function (form) {
            setWishlistQuantity(form);

            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').prop('disabled', false);

                if (!data.status) {
                    $('.js-wishlist-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-wishlist-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-wishlist-hide').slideUp(200);
                }
            }, 'json');
        }
    });

    $('.js-new-wishlist-form').validate({
        submitHandler: function (form) {
            setWishlistQuantity(form);

            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').prop('disabled', false);

                if (!data.status) {
                    $('.js-wishlist-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-wishlist-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-wishlist-hide').slideUp(200);
                }
            }, 'json');
        }
    });
}

function initMultiselect(multiselect) {
    const $multiselects = $(multiselect.selector),
        settings = multiselect.settings || {};

    $multiselects.not('.is-loaded').each(function () {
        let $multiselect = $(this),
            defaults = {
                templates: {
                    button: `
                        <button type="button" class="multiselect dropdown-toggle" data-toggle="dropdown">
                            <span class="multiselect-selected-text"></span>
                            <i class="fa fa-caret-down"></i>
                        </button>
                    `
                },
                buttonClass: 'c-btn has-icon ' + ($multiselect.data('btn-class') || 'c-btn--shadow'),
                buttonContainer: '<div class="multiselect__container ' + ($multiselect.data('container-class') || '') + '" />',
                enableHTML: true
            };

        $multiselect.multiselect(Object.assign(defaults, settings));

        $multiselect.addClass('is-loaded');
    });
}

function fixSpinnerInputHeight() {
    $(window).on('resize', function () {
        const $spinners = $('body').find('.ui-spinner-input');

        $spinners.each(function () {
            const $spinner = $(this),
                $spinnerWrapper = $spinner.parent('.ui-spinner'),
                spinnerHeight = $spinner.outerHeight(true),
                spinnerWrapperHeight = $spinnerWrapper.outerHeight(true);

            if (spinnerHeight != spinnerWrapperHeight) {
                $spinnerWrapper.outerHeight(spinnerHeight);
            }
        });
    });
}

$(function () {
    initMultiselect({
        selector: '.js-multiselect'
    });

    fixSpinnerInputHeight();

    $('.js-remote-modal').on('hidden.bs.modal', function () {
        $(this).removeClass('is-loaded');
    });

    $('.js-listing-page').on('click', '.pager__item a', function () {
        if ($('.js-pager-scroll-here').length) {
            $('.js-pager-scroll-here').first().slideHere(20);
        }
    });

    $(document).on('focus', 'input.ui-spinner-input', function () {
        $(this).val(parseInt($(this).val()));
    });

    $(document).on('spinchange blur', 'input.ui-spinner-input', function (e, ui) {
        const $spinnerInput = $(this),
            max = parseInt($spinnerInput.attr('max')),
            min = parseInt($spinnerInput.attr('min')),
            step = $spinnerInput.spinner('option', 'step');

        let value = parseInt($spinnerInput.val()),
            append = '';

        if ($spinnerInput.data('spinner-append')) {
            append = $spinnerInput.data('spinner-append');
        }

        if (value > max) {
            value = max;
        }

        if (value < min) {
            if (step && min < step) {
                value = step;
            } else {
                value = min;
            }
        }

        $spinnerInput.val(_.template(Spinner.template)({
            value: value,
            append: append
        }));
    });

    $('.js-wishlist-info-close').on('click', function (e) {
        e.preventDefault();

        $('.js-wishlist-info').slideUp();

        setCookie('wishlistInfoMessage', true, 14);
    });
});